import { FC } from 'react'
import { useTranslation } from 'next-i18next'

import styles from './PricingSection.module.css'

type Props = {
  currencySymbol: string
  total: string | null
  isPriceError?: boolean
}

export const PricingSection: FC<Props> = ({ currencySymbol, total, isPriceError }) => {
  const { t } = useTranslation()

  return (
    <div>
      <div className={styles.pricingContainer}>
        <div>
          <p>{t('LOCKER.LABEL.FEE')}</p>
          <p>{currencySymbol}</p>
          <p>{total || '----'}</p>
        </div>
      </div>
      {isPriceError && <p className={styles.error}>{t('BOOKING.ERRORS.PRICE_FETCH_FAILED')}</p>}
    </div>
  )
}
